import React from 'react';
import {
    useBreakpoint,
    BREAKPOINTS
} from 'tradera-components/breakpoint/breakpoint';

import './site-subheader.scss';

const SiteSubheader = ({ className, children, ...otherProps }) => {
    const currentBreakpoint = useBreakpoint();
    const responsiveClassNames =
        currentBreakpoint === BREAKPOINTS.XS ||
        currentBreakpoint === BREAKPOINTS.SM
            ? 'border-bottom'
            : 'bg-gray-100 border-top border-bottom';
    return (
        <div
            className={`site-subheader ${responsiveClassNames} ${className ||
                ''}`}
            {...otherProps}>
            <div className="site-width pl-3 h-100 d-flex align-items-center">
                {children}
            </div>
        </div>
    );
};

export default SiteSubheader;
